import MagicLinkForm from 'profile/login/forms/MagicLinkForm';

const MagicLinkForms = (props) => {
  const { slug } = props;
  return (
    <div className="c7-account-login--returning-customer">
      <h4>Magic Link</h4>
      <MagicLinkForm
        redirectLink={`/club/${slug}/signup`}
        loginLink={`/club/${slug}/login`}
      />
    </div>
  );
};

export default MagicLinkForms;
